import script from "./KpCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./KpCell.vue?vue&type=script&setup=true&lang=ts"

import "./KpCell.vue?vue&type=style&index=0&id=72da46cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72da46cf"]])

export default __exports__